
































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import JudgeScore from '@/evaluations/models/judge-score'
import RatingService from '@/evaluations/services/rating-service'
import uniqBy from 'lodash/uniqBy'

@Component
export default class ScoreAssessorsTable extends Vue {
  @Prop({ type: String })
  private evaluationId!: string

  @Prop({ type: String })
  private candidateId!: string

  private headers: any[] = []
  private items: any[] = []

  private scores: JudgeScore[] = []

  private get competences() {
    const scoreCompetences = this.scores.map((s) => ({
      id: s.competenceId,
      name: s.competenceName,
    }))

    return uniqBy(scoreCompetences, 'id')
  }

  private get judges() {
    const scoreJudges = this.scores.map((s) => ({
      id: s.judgeId,
      name: s.judgeName,
    }))

    return uniqBy(scoreJudges, 'id')
  }

  private async setupTable() {
    this.scores = await RatingService.findForAssessors(
      this.evaluationId,
      this.candidateId
    )

    this.setupHeader()
    this.createItems()
  }

  private setupHeader() {
    this.headers.push({
      text: this.$tc('competences.entities.competence.singular'),
      value: 'competence',
      sortable: false,
    })

    for (const judge of this.judges) {
      this.headers.push({
        text: judge.name,
        value: `judge-${judge.id}`,
        sortable: false,
      })
    }
  }

  private createItems() {
    for (const competence of this.competences) {
      const item: any = { competence: competence.name }

      for (const judge of this.judges) {
        const score = this.scores.find(
          (s) => s.competenceId === competence.id && s.judgeId === judge.id
        )
        item[`judge-${judge.id}`] = score?.judgeScore
        item.targetScore = score?.targetScore || 0
      }

      this.items.push(item)
    }
  }

  private ratingAvailable(item: any, judge: any) {
    const val = item[`judge-${judge.id}`]
    return val && val !== 0
  }

  private discrepancy(item: any, judge: any) {
    return item[`judge-${judge.id}`] - item.targetScore
  }

  private isPositive(item: any, judge: any) {
    const ratingAvailable = this.ratingAvailable(item, judge)
    const discrepancyPositive = this.discrepancy(item, judge) >= 0
    return ratingAvailable && discrepancyPositive
  }

  private isNegative(item: any, judge: any) {
    const ratingAvailable = this.ratingAvailable(item, judge)
    const discrepancyNegative = this.discrepancy(item, judge) < 0
    return ratingAvailable && discrepancyNegative
  }

  private async mounted() {
    await this.setupTable()
  }
}
